import { render } from "./RepairsItem.vue?vue&type=template&id=7925c310"
import script from "./RepairsItem.vue?vue&type=script&lang=js"
export * from "./RepairsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__